// @generated by protoc-gen-es v2.6.3 with parameter "keep_empty_files=true,target=js+dts"
// @generated from file proto/model/trip/event.proto (package carmen, syntax proto3)
/* eslint-disable */

import { enumDesc, fileDesc, messageDesc, tsEnum } from "@bufbuild/protobuf/codegenv2";
import { file_google_protobuf_duration } from "@bufbuild/protobuf/wkt";
import { file_proto_model_core_common } from "../core/common_pb";
import { file_proto_model_core_timeofday } from "../core/timeofday_pb";
import { file_proto_model_entity_place } from "../entity/place_pb";

/**
 * Describes the file proto/model/trip/event.proto.
 */
export const file_proto_model_trip_event = /*@__PURE__*/
  fileDesc("Chxwcm90by9tb2RlbC90cmlwL2V2ZW50LnByb3RvEgZjYXJtZW4iJQoPQWN0aXZpdHlEZXRhaWxzEhIKCmJvb2tpbmdfaWQYASABKAkiJQoNVHJhdmVsRGV0YWlscxIUCgxpdGluZXJhcnlfaWQYASABKAkiIQoLRm9vZERldGFpbHMSEgoKYm9va2luZ19pZBgBIAEoCSLiAwoFRXZlbnQSEAoIZXZlbnRfaWQYASABKAkSEwoLc2NoZWR1bGVfaWQYAiABKAkSDgoGZGF5X2lkGAMgAygJEg8KB3N0YXlfaWQYBCADKAkSDQoFdGl0bGUYBSABKAkSEwoLZGVzY3JpcHRpb24YBiABKAkSHAoFcGxhY2UYByABKAsyDS5jYXJtZW4uUGxhY2USJQoKc3RhcnRfdGltZRgIIAEoCzIRLmNhcm1lbi5UaW1lT2ZEYXkSKwoIZHVyYXRpb24YCSABKAsyGS5nb29nbGUucHJvdG9idWYuRHVyYXRpb24SPQoXYXBwcm94aW1hdGVfdGltZV9vZl9kYXkYCiABKA4yHC5jYXJtZW4uQXBwcm94aW1hdGVUaW1lT2ZEYXkSDwoHYWxsX2RheRgLIAEoCBIlCgpldmVudF90eXBlGAwgASgOMhEuY2FybWVuLkV2ZW50VHlwZRIrCghhY3Rpdml0eRgNIAEoCzIXLmNhcm1lbi5BY3Rpdml0eURldGFpbHNIABInCgZ0cmF2ZWwYDiABKAsyFS5jYXJtZW4uVHJhdmVsRGV0YWlsc0gAEiMKBGZvb2QYDyABKAsyEy5jYXJtZW4uRm9vZERldGFpbHNIAEIJCgdkZXRhaWxzKrcBCglFdmVudFR5cGUSGgoWRVZFTlRfVFlQRV9VTlNQRUNJRklFRBAAEhcKE0VWRU5UX1RZUEVfQUNUSVZJVFkQARIVChFFVkVOVF9UWVBFX1RSQVZFTBACEhMKD0VWRU5UX1RZUEVfRk9PRBADEhgKFEVWRU5UX1RZUEVfRlJFRV9USU1FEAQSEwoPRVZFTlRfVFlQRV9SRVNUEAUSGgoWRVZFTlRfVFlQRV9QTEFDRUhPTERFUhAGQihaJmdpdGh1Yi5jb20veXVuYWNhYmEvY2FybWVuL3Byb3RvL21vZGVsYgZwcm90bzM", [file_google_protobuf_duration, file_proto_model_core_common, file_proto_model_core_timeofday, file_proto_model_entity_place]);

/**
 * Describes the message carmen.ActivityDetails.
 * Use `create(ActivityDetailsSchema)` to create a new message.
 */
export const ActivityDetailsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_event, 0);

/**
 * Describes the message carmen.TravelDetails.
 * Use `create(TravelDetailsSchema)` to create a new message.
 */
export const TravelDetailsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_event, 1);

/**
 * Describes the message carmen.FoodDetails.
 * Use `create(FoodDetailsSchema)` to create a new message.
 */
export const FoodDetailsSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_event, 2);

/**
 * Describes the message carmen.Event.
 * Use `create(EventSchema)` to create a new message.
 */
export const EventSchema = /*@__PURE__*/
  messageDesc(file_proto_model_trip_event, 3);

/**
 * Describes the enum carmen.EventType.
 */
export const EventTypeSchema = /*@__PURE__*/
  enumDesc(file_proto_model_trip_event, 0);

/**
 * @generated from enum carmen.EventType
 */
export const EventType = /*@__PURE__*/
  tsEnum(EventTypeSchema);

